module.exports = __webpack_public_path__ + "img/outline_new_wap@2x.e1b445ea.png";